import browser from '@motionelements/core/src/store/modules/browser.js';

export default {
  namespaced: true,
  state: () => browser.state,
  getters: browser.getters,
  actions: browser.actions,
  mutations: browser.mutations,
};
